import {
  Box,
  Link,
  Typography,
  Dialog,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  TextareaAutosize,
  FormControl,
  Card,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "./scMembers.module.scss";
import constants from "../../config/constants.json";
import Pagination from "../common/pagination/pagination";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomCheckbox,
  CustomDatePicker,
  CustomEditIcon,
  CustomInputLabel,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelect,
  CustomTextFeild,
  StyledDateContainer,
} from "../common/StyledComponents/StyledFields";
import CloseIcon from "@mui/icons-material/Close";
import { BeatLoader, BounceLoader, ClipLoader } from "react-spinners";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../infrastructure/backendService";
import ErrorPopup from "../common/ErrorPopup";
import toast, { Toaster } from "react-hot-toast";
import apiPath from "../../config/apiPaths.json";
import ToastComponent from "../common/toastComponent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import HcccTimePicker from "../common/customTimePicker/hcccTimePicker";
import Calendar from "../devotee/dashboard/events/calenderComponent";
import { object, string, ValidationError } from "yup";
import { isEmpty, isNil } from "lodash";

interface ErrorMessageTypes {
  title: string;
  categoryType: string;
  hostName: string;
  startDate: string;
  startTime: string;
  description: string;
  scheduledTypeId: string;
}

const ScheduleSCMeetingsComponent = () => {
  const [searchItems, setSearchItem] = useState([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [newScmDetails, setNewScmDetails] = useState<any[]>([]);
  const [selectedUsernames, setSelectedUsernames] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openScheduleFieldsDialog, setOpenScheduleFieldsDialog] =
    useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const scheduleFormFields = {
    title: "",
    categoryType: "",
    hostName: "",
    startDate: "",
    startTime: "",
    description: "",
    scheduledTypeId: "",
  };
  const [scheduleFormData, setScheduleFormData] = useState({
    ...scheduleFormFields,
  });
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    ...scheduleFormFields,
  });
  const [scmMeetingScheduleList, setScmMeetingScheduleList] = useState<any[]>(
    []
  );
  const [categoryTypeList, setCategoryTypeList] = useState<any[]>([]);
  const [meetingConfirmedDate, setMeetingConfirmedDate] = useState("");
  const [showTableComponent, setShowTableComponent] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [categoryTypeError, setCategoryTypeError] = React.useState("");
  const [editMeetingData, setEditMeetingData] = useState<any[]>([]);
  const currentDate = new Date();
  const [selectedDate, setSelectedDate] = useState(formatDate(currentDate));
  const [selectedRowId, setSelectedRowId] = useState();
  const [showAddScheduleButton, setShowAddScheduleButton] = useState<boolean>(true);
  function formatDate(date: Date): string {
    const day = date?.getDate();
    const month = date?.getMonth() + 1;
    const year = date?.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedMonth}/${formattedDay}/${year}`;
  }

  const [pageSize, setPageSize] = useState<number>(20);

  const prevPageNumber = usePrevious(pageNumber);


  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }

  useEffect(() => {
    // Check if previous values are not undefined to ensure this is not the first render
    // And then check if the current values differ from the previous ones
    if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
      getMeetingScheduleApi();
    }
  }, [pageNumber, prevPageNumber, pageSize]);

  useEffect(() => {
    getMeetingScheduleApi();
  }, []);

  const handleDateSelection = (date: string) => {
    setSelectedDate(date);
  };

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  useEffect(() => {
    setDatePickerOpen(false);
  }, [scheduleFormData.startDate]);

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
    setScheduleFormData(scheduleFormFields);
    setShowAddScheduleButton(true);
  };

  const handleScheduleFieldsClose = () => {
    setOpenScheduleFieldsDialog(false);
  };

  const handleAddSchedule = () => {
    setScheduleFormData(scheduleFormFields);
    setShowAddScheduleButton(true);
    getCategoryApi();
    setOpenScheduleFieldsDialog(true);
  };

  const handleScheduleCancel = () => {
    setScheduleFormData(scheduleFormFields);
  };

  // const handleEdit = (row: any) => {
  //   console.log("Clicked row data:", row);
  //   setEditMeetingData(row);
  //   // You can access other properties of 'row' here, like row.meetingName, row.meetingDate, etc.
  //   getCategoryApi();
  //   setOpenScheduleFieldsDialog(true);
  // }

  const handleEdit = (row: any) => {
    setSelectedRowId(row.id);
    setShowAddScheduleButton(false);
    getCategoryApi();
    setEditMeetingData(row);
    // Access specific properties from row object
    const title = row.meetingName;
    const hostName = row.meetingHost;
    const startDate = row.meetingDate;
    const startTime = row.meetingStartTime;
    const description = row.meetingDescription;
    const categoryType = row.meetingType;
    const scheduledTypeId = row.scheduledTypeId;
    // ... access other properties as needed

    // Update scheduleFormData with retrieved data
    setScheduleFormData({
      ...scheduleFormData,
      title,
      hostName,
      startDate,
      startTime,
      description,
      categoryType,
      scheduledTypeId,

      // ... update other fields with corresponding row data
    });


    setOpenScheduleFieldsDialog(true);
  }

  const getMeetingScheduleApi = () => {
    setLoading(true);
    apiRequest({
      method: "GET",
      endpoint: apiPath.scmMeetingScheduleGetAndUpdateApi,
      includeToken: true,
      params: {
        page: pageNumber - 1,
        size: 20,
        scm: true,
      },
    })
      .then((res) => {
        setScmMeetingScheduleList(res.data.content);
        setOpenSuccessDialog(false);
        setShowTableComponent(true);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }


  const getCategoryApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.scmScheduleCategoryTypeGetApi,
      includeToken: true,
    })
      .then((res) => {
        setCategoryTypeList(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const validationSchema = object().shape({
    title: string().required("Title is required"),
    hostName: string().required("Host Name is required"),
    startDate: string().required("Start Date is required"),
    startTime: string().required("Start Time is required"),
    description: string().required("Description is required"),
  });

  const handleSchedule = async () => {
    const errors: ErrorMessageTypes = {
      title: "",
      categoryType: "",
      hostName: "",
      startDate: "",
      startTime: "",
      description: "",
      scheduledTypeId: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(scheduleFormData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      if (!scheduleFormData.categoryType) {
        setCategoryTypeError("Category Type is required.");
        return;
      }
      // Call your API or perform other actions here
      addScheduleApiCall();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
      if (!scheduleFormData.categoryType) {
        setCategoryTypeError("Category Type is required.");
        return;
      }
    }
  };


  const addScheduleApiCall = () => {
    setIsLoading(true);
    const reqBody = {
      meetingName: scheduleFormData.title,
      meetingHost: scheduleFormData.hostName,
      meetingDate: scheduleFormData.startDate,
      meetingStartTime: scheduleFormData.startTime,
      meetingDescription: scheduleFormData.description,
      scheduledTypeId: scheduleFormData.scheduledTypeId,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.scmMeetingScheduleGetAndUpdateApi,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setIsLoading(false);
        setOpenScheduleFieldsDialog(false);
        setOpenSuccessDialog(true);
        setScheduleFormData(scheduleFormFields);
        setMeetingConfirmedDate(res.data.meetingDate);
        getMeetingScheduleApi();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleUpdateSchedule = async () => {
    const errors: ErrorMessageTypes = {
      title: "",
      categoryType: "",
      hostName: "",
      startDate: "",
      startTime: "",
      description: "",
      scheduledTypeId: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(scheduleFormData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      if (!scheduleFormData.categoryType) {
        setCategoryTypeError("Category Type is required.");
        return;
      }
      // Call your API or perform other actions here
      updateScheduleApiCall();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
      if (!scheduleFormData.categoryType) {
        setCategoryTypeError("Category Type is required.");
        return;
      }
    }
  };

  const updateScheduleApiCall = () => {
    setIsLoading(true);
    const reqBody = {
      meetingName: scheduleFormData.title,
      meetingHost: scheduleFormData.hostName,
      meetingDate: scheduleFormData.startDate ? dayjs(scheduleFormData.startDate).format("MM-DD-YYYY") : null,
      meetingStartTime: scheduleFormData.startTime,
      meetingDescription: scheduleFormData.description,
      scheduledTypeId: scheduleFormData.scheduledTypeId,
    };
    apiRequest({
      method: "PUT",
      endpoint: `${apiPath.scmMeetingScheduleGetAndUpdateApi}/${selectedRowId}`,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setIsLoading(false);
        setOpenScheduleFieldsDialog(false);
        setOpenSuccessDialog(true);
        setScheduleFormData(scheduleFormFields);
        setMeetingConfirmedDate(res.data.meetingDate);
        getMeetingScheduleApi();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "startDate") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");
      setDatePickerOpen(false);

      setScheduleFormData({
        ...scheduleFormData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
    } else if (field === "categoryType") {
      setCategoryTypeError("");
      // Extract and set the selected category type ID
      let category: any;
      category = categoryTypeList?.filter(
        (item: any) => item.type === value
      )
      setScheduleFormData({
        ...scheduleFormData,
        [field]: value,
        scheduledTypeId: category[0].id, // Assuming scheduledTypeId is the key for the category type ID
      });
    } else {
      setScheduleFormData({
        ...scheduleFormData,
        [field]: value,
      });
    }
    setDatePickerOpen(false);
  };

  const formatedDate = (date: Date) => {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const parseDate = (dateString: string) => {
    const [month, day, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day); // Months are 0-indexed in JavaScript Date
  };
  const formattedDate = formatedDate(currentDate);

  const formatCurrentDate = parseDate(formattedDate)

  const listItemTable = () => {
    if (scmMeetingScheduleList.length === 0) {
      return (
        <Typography
          sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}
        >
          <b>{constants.NO_RECORDS_FOUND}</b>
        </Typography>
      );
    }
    return (
      <>
        <Typography className={styles.tableHeading}>
          Upcoming Meetings
        </Typography>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Scheduled Meeting ID</th>
                <th className={styles.tableHorizontal}>Scheduled Type ID</th>
                <th className={styles.tableHorizontal}>Meeting Host</th>
                <th className={styles.tableHorizontal}>Meeting Date</th>
                <th className={styles.tableHorizontal}>Meeting Start Time</th>
                <th className={styles.tableHorizontal}>Meeting End Time</th>
                <th className={styles.tableHorizontal}>Meeting Name</th>
                <th className={styles.tableHorizontal}>Meeting Type</th>
                <th className={styles.tableHorizontal}>Meeting Description</th>
                <th className={styles.tableHorizontal}>Meeting Status</th>
                <th className={styles.tableHorizontal}>Active Member Count</th>
                <th className={styles.tableHorizontal}>Status</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="searchScmData">
              {scmMeetingScheduleList.map((row: any, id: number) => (
                <tr key={id} className={styles.tableRow}>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.id}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.scheduledTypeId}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingHost}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingDate}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingStartTime !== null
                      ? row.meetingStartTime
                      : "--"}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "center",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingEndTime !== null ? row.meetingEndTime : "--"}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingName}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingType}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingDescription}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "center",
                      verticalAlign: "top",
                    }}
                  >
                    {row.meetingStatus !== null ? row.meetingStatus : "--"}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {row.activeMemberCount !== null
                      ? row.activeMemberCount
                      : "--"}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    --
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                      verticalAlign: "top",
                    }}
                  >
                    {parseDate(row.meetingDate) > formatCurrentDate ?
                      <Box onClick={() => handleEdit(row)}>
                        <CustomEditIcon />
                      </Box>
                      : "--"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalRecords > 20 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "10px",
                marginTop: "3px",
              }}
            >
              <Pagination
                items={totalRecords}
                itemsPerPage={20}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <Grid sx={{ marginTop: "10px" }}>
          <CommonOutlinedButton
            sx={{ textTransform: "inherit", fontWeight: "600" }}
            onClick={handleAddSchedule}
          >
            Schedule a Meeting
          </CommonOutlinedButton>
        </Grid>
      </>
    );
  };

  const categoryTypeDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.donationDropdownMainContainer}>
        <CustomSelect
          defaultValue=""
          value={scheduleFormData.categoryType}
          id="purposeOfDonations"
          IconComponent={KeyboardArrowDownIcon}
          onChange={(e) => {
            setErrorMessage({ ...errorMessage, categoryType: "" });
            handleFieldChange("categoryType", e.target.value);
          }}
          className={
            errorMessage.categoryType ? styles.errorTextField : styles.textField
          }
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {categoryTypeList.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item.type}>
              {item.type}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.categoryType && errorMessage.categoryType && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.categoryType}
          </Typography>
        )}
      </FormControl>
    );
  };

  const startDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          id="dob"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  scheduleFormData.startDate
                    ? dayjs(scheduleFormData.startDate, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, startDate: "" });
                  handleFieldChange("startDate", value);
                  setDatePickerOpen(false);
                }}
                disablePast
                className={
                  errorMessage.startDate
                    ? styles.errorDateFeild
                    : styles.dateFeild
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.startDate ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.startDate}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const handleTimeFieldChange = (field: any, value: any) => {
    if (field === "startTime") {
      setScheduleFormData((prevItem) => ({ ...prevItem, [field]: value }));
      setErrorMessage({ ...errorMessage, [field]: "" });
    } else {
      setScheduleFormData((prevItem) => ({ ...prevItem, [field]: value }));
      if (field !== "startTime") {
        setErrorMessage({ ...errorMessage, [field]: "" });
      }
    }
  };

  const startTimePicker = () => {
    return (
      <Box>
        <Grid>
          <HcccTimePicker
            handleFieldChange={handleTimeFieldChange}
            labelName="Start Time"
            fieldName="startTime"
            className={
              errorMessage.startTime ? styles.errorTextField : styles.textField
            }
            value={scheduleFormData.startTime}
          />
          {errorMessage.startTime ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.startTime}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Box>
    );
  };

  const scheduleMeetingFieldsDialog = () => {

    return (
      <>
        <Dialog
          open={openScheduleFieldsDialog}
          onClose={handleScheduleFieldsClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "100%",
              height: "auto",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Add Steering Committee Meeting Schedule"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleScheduleFieldsClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={8} item>
                  {CustomRequiredInputLabel("Add Title", true)}
                  <CustomTextFeild
                    id="signInName"
                    fullWidth
                    required
                    value={scheduleFormData.title}
                    onChange={(e) => {
                      handleFieldChange("title", e.target.value);
                      setErrorMessage({ ...errorMessage, title: "" });
                    }}
                    className={
                      errorMessage.title
                        ? styles.errorTextField
                        : styles.textField
                    }
                    onBlur={() => {
                      const inputUserName =
                        scheduleFormData.title.toUpperCase();
                      handleFieldChange("title", inputUserName);
                    }}
                  // onKeyDown={(e) => handleKeyDownuser(e, "title")}
                  />
                  {errorMessage.title ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.title}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Category Type", true)}
                  {categoryTypeDropdown()}
                  {/* Display error if category type is empty */}
                  {categoryTypeError && (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {categoryTypeError}
                    </Typography>
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Host Name", true)}
                  <CustomTextFeild
                    id="signInName"
                    fullWidth
                    required
                    value={scheduleFormData.hostName}
                    onChange={(e) => {
                      handleFieldChange("hostName", e.target.value);
                      setErrorMessage({ ...errorMessage, hostName: "" });
                    }}
                    className={
                      errorMessage.hostName
                        ? styles.errorTextField
                        : styles.textField
                    }
                    onBlur={() => {
                      const inputUserName =
                        scheduleFormData.hostName.toUpperCase();
                      handleFieldChange("hostName", inputUserName);
                    }}
                  // onKeyDown={(e) => handleKeyDownuser(e, "title")}
                  />
                  {errorMessage.hostName ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.hostName}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Start Date", true)}
                  {startDatePicker()}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {startTimePicker()}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={30} sm={13} item sx={{ marginTop: "15px" }}>
                  {CustomRequiredInputLabel("Description", true)}
                  <TextareaAutosize
                    id="description"
                    style={{ width: "100%", height: "79px", marginTop: "0" }}
                    required
                    onChange={(e) => {
                      handleFieldChange("description", e.target.value);
                      setErrorMessage({ ...errorMessage, description: "" });
                    }}
                    className={
                      errorMessage.description
                        ? styles.errorTextField
                        : styles.textArea
                    }
                    value={scheduleFormData.description}
                  ></TextareaAutosize>
                  {errorMessage.description ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.description}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid sx={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                {showAddScheduleButton ?
                  <CommonButton
                    sx={{ textTransform: "inherit" }}
                    onClick={handleSchedule}
                  >
                    Schedule
                  </CommonButton>
                  : <CommonButton
                    sx={{ textTransform: "inherit" }}
                    onClick={handleUpdateSchedule}
                  >
                    Update Schedule
                  </CommonButton>}
                <CommonOutlinedButton onClick={handleScheduleCancel}>
                  Reset
                </CommonOutlinedButton>
              </Grid>
            </Box>
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const SuccessDialog = () => {
    return (
      <>
        <Dialog
          open={openSuccessDialog}
          onClose={handleSuccessDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "562px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Steering Committee Meeting"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleSuccessDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src="/images/successImage.svg" />
            <Typography style={{ fontWeight: "400", marginBottom: "20px" }}>
              Scheduled a meeting on <b>{meetingConfirmedDate}</b>
            </Typography>
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const renderEmptyData = (): React.ReactElement => {
    return (
      <>
        {loading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "300px",
            }}
          >
            <BounceLoader color="#22A699" loading={loading} size={45} />
            <span
              style={{
                marginLeft: "8px",
                fontSize: "15px",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Please wait...
            </span>
          </div>
        ) : (
          "empty image"
        )}

      </>
    );
  };

  return (
    <Box>
      <ToastComponent />
      {scheduleMeetingFieldsDialog()}
      {SuccessDialog()}
      <Grid>
        {showTableComponent ? listItemTable() : renderEmptyData()}
      </Grid>
    </Box>
  );
};

export default ScheduleSCMeetingsComponent;